// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wallet-payment-button-delimiter {
    text-align: center;
    margin: 8px 0;
    line-height: 21px;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.wallet-payment-button.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,iBAAiB;AACrB","sourcesContent":[".wallet-payment-button-delimiter {\n    text-align: center;\n    margin: 8px 0;\n    line-height: 21px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
